import Vue from 'vue'

let moment = require('moment')
moment.locale('fr')

Vue.prototype.$getClassNameRecap = function (statut) {
  switch (statut) {
    case 'En cours':
      return 'text-warning'
      break
    case 'En attente de décision':
      return 'text-warning'
      break
    case 'En attente':
      return 'text-warning'
      break
    case 'En cours':
      return 'text-warning'
      break
    case 'Annulé / Refusé':
      return 'text-danger'
      break
    case 'Cloturé / Validé':
      return 'text-green'
      break
    case 'En attente de payement':
      return 'text-aqua'
      break
    default:
      return ''
  }
}

Vue.prototype.$consoleLog = function () {
  console.log(...arguments)
}

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

// Vue.prototype.$sortCompareAdvanced = function(a, b, key) {
//   if (typeof a[key] === 'number' && typeof b[key] === 'number') {
//     // If both compared fields are native numbers
//     return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0
//   } else {
//     // Stringify the field data and use String.localeCompare
//     return this.$flatten(a)
//       [key].toString()
//       .localeCompare(this.$flatten(b)[key].toString(), undefined, {
//         numeric: true
//       })
//   }
// }
//
// Vue.prototype.$flatten = function(obj) {
//   var root = {}
//   ;(function tree(obj, index) {
//     var suffix = toString.call(obj) == '[object Array]' ? ']' : ''
//     for (var key in obj) {
//       if (!obj.hasOwnProperty(key)) continue
//       root[index + key + suffix] = obj[key]
//       if (toString.call(obj[key]) == '[object Array]')
//         tree(obj[key], index + key + suffix + '[')
//       if (toString.call(obj[key]) == '[object Object]')
//         tree(obj[key], index + key + suffix + '.')
//     }
//   })(obj, '')
//   return root
// }


Vue.prototype.$sortCompareAdvanced = function (aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
  const a = aRow[key] // or use Lodash `_.get()`
  const b = bRow[key]
  if (
    (typeof a === 'number' && typeof b === 'number') ||
    (a instanceof Date && b instanceof Date)
  ) {
    // If both compared fields are native numbers or both are native dates
    return a < b ? -1 : a > b ? 1 : 0
  } else {
    // Otherwise stringify the field data and use String.prototype.localeCompare
    return this.$toString(a).localeCompare(this.$toString(b), compareLocale, compareOptions)
  }
}

// Helper function to stringify the values of an Object
Vue.prototype.$toString = function (value) {
  if (value === null || typeof value === 'undefined') {
    return ''
  } else if (value instanceof Object) {
    return Object.keys(value)
      .sort()
      .map(key => toString(value[key]))
      .join(' ')
  } else {
    return String(value)
  }
}
// Pluralize
Vue.prototype.$pluralize = function (value) {
  if (value === null || typeof value === 'undefined') {
    return ''
  } else if (value>1) {
    return 's'
  } else {
    return  ''
  }
}


// Helper function to stringify the values of an Object
Vue.prototype.$formatDate= function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
  if (value == null) return ''
  return moment(value, fmtIn).format(fmtOut)
}

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        console.log(binding);
        console.log(vnode.context);
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});




// WEBPACK FOOTER //
// ./src/utils.js